/**
 * Returns true when the application is running inside an iframe.
 */
export function isInIframe(): boolean {
	return window.self !== window.top;
}
